import PlaceBidLabel from './place-bid-label'
import styles from './offer-dialog.module.css'

/** Consistent equal-width primary actions on every individual item surface. */
export default function ItemMarketActions({
	listed,
	showOffer,
	buying = false,
	hasOffer = false,
	onBuy,
	onOffer
}: {
	listed: boolean
	showOffer: boolean
	buying?: boolean
	hasOffer?: boolean
	onBuy: () => void
	onOffer: () => void
}) {
	if (!listed && !showOffer) return null
	return (
		<div className={styles.itemActions}>
			{listed && (
				<button type="button" className={styles.buyAction} onClick={onBuy} disabled={buying}>
					{buying ? 'Checking listing…' : 'Buy now'}
				</button>
			)}
			{showOffer && (
				<button type="button" className={styles.offerAction} onClick={onOffer}>
					{hasOffer ? 'Cancel offer' : <PlaceBidLabel />}
				</button>
			)}
		</div>
	)
}
